module.exports = __webpack_public_path__ + "media/old_images/spinner-c38c5f54.svg";